import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  holiday: {
    color: '#f7f8fa',
    fontSize: 14,
    padding: 15,
  },
  occasion: {
    color: '#f7f8fa',
    fontSize: 20,
    paddingLeft: 15,
    paddingBottom: 5,
  },
  date: {
    color: '#f7f8fa',
    fontSize: 14,
    paddingLeft: 15,
    paddingBottom: 5,
  },
  welcome: {
    color: '#f7f8fa',
    fontSize: 30,
    textAlign: 'center',
  },
}));
